export default {
  desatualizado: true,
  loading: false,
  dados: {
    blacklist: {
      emissores: [],
      gestoras: [],
      ratings: [],
      subtipos1: [],
    },
    whitelist: {
      emissores: [],
      gestoras: [],
      ratings: [],
      subtipos1: [],
    },
    histogram: {
      emissores: {},
      gestoras: {},
      ratings: {},
      subtipos1: {},
    },
  },
}
